export default __webpack_public_path__ + "assets/images/thumbnail-3d.png";